// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Independence80_wrap__gCm51","heroTransparent":"Independence80_heroTransparent__aYZ58","badgeRow":"Independence80_badgeRow__xDIDY","banner":"Independence80_banner__JcYtP"};